import React, { ReactElement } from "react";
import PlanCategory from "@templates/Initiatives/Nachu/PlanCategory";
import TemplateSEO from "@seo/TemplateSEO";
import { HousePlan, HouseType } from "@interfaces/plans";
//
const slug = HouseType.Jengapolepole;

interface Props {
    plans: HousePlan[];
}

function NachuPlanCategory({ plans }: Props): ReactElement {
    return (
        <>
            {/* @ts-ignore */}
            <TemplateSEO />
            <PlanCategory slug={slug} plans={plans} />
        </>
    );
}

// This function gets called at build time
export async function getStaticProps() {
    let { fetchBuildingPlans } = require("@utils/fetchBuildData");
    const plans = await fetchBuildingPlans(true, { tags: "NACHU" });

    function filterPlans(plans: HousePlan[]) {
        return plans.filter((plan) => plan.house_type == slug);
    }

    return {
        props: {
            plans: filterPlans(plans),
        },
        // revalidate: 60 * 60 * 24 * 1, // 1 days
    };
}
export default NachuPlanCategory;
